import { RootState } from "../hooks";

export const getEmailSelector = (state: RootState) => state.email;